import { reactive } from "vue";
import axios from "axios";
import router from "@/router";
import Vue from "vue";
import { exam } from "@/js/exam";
import {session} from "@/js/session";

export const prepareExam = reactive({
  rowData: [],
  rowUserData: [],
  rowExam: [],
  selected: [],
  preparedExam: false,
  previewExam: false,
  exam: null,
  years: [1, 2, 3, 4, 5, 6, 7, 8],
  loading: false,
  error: null,
  async generateRowData() {
    this.error = null;
    //const params = {
    //    userId: this.userId,
    //    date: this.selected['date'] != null && this.selected['time'] != null && this.selected['time']['HH'] != null && this.selected['time']['mm'] != null ? this.selected['date'] + 'T' + this.selected['time']['HH'] + ':' + this.selected['time']['mm'] : new Date().toJSON()
    //};
    this.loading = true;
    await axios({
      async: true,
      crossDomain: true,
      url: process.env.VUE_APP_ROOT_API + "getExamUserDetail/", // get disciplines and exams for current year
      method: "get",
    })
      .then((response) => {
        this.rowUserData = response.data;
        if (this.rowUserData.length == 0)
          this.error =
            "ERROR: We didn't found any exams programmed for the student.";
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
  },

  async PrepareTeacherExam(
    pkDiscipline,
    PkCollege,
    PkSection,
    Lang,
    Year,
    semester
  ) {
    this.loading = true;
    try {
      let response = await axios({
        async: true,
        crossDomain: true,
        url: process.env.VUE_APP_ROOT_API + "prepareExamForTeach/",
        method: "post",
        data: {
          PKDiscipline: pkDiscipline,
          PkCollege: PkCollege,
          PkSection: PkSection,
          Lang: Lang,
          Year: Year,
          Semester: semester + "",
        },
      });
      console.log(response.data);
      if (response.data.error != null) {
        this.loading = false;
        this.error = response.data.error;
      } else if (
        response.data["id"] > 0 &&
        response.data["status"] != "Finished"
      ) {
        this.selected = [];
        this.preparedExam = true;
        this.exam = response.data;
        this.loading = false;
      }
    } catch {}
  },

  async prepareExam(examId, teacher) {
    const canSimulate = await session.getCanSimulate();
    if(!teacher && !canSimulate){
      Vue.notify({
        group: "appWarning",
        type: "error",
        text: "Exams can not be simulated",
      });
      return;
    }
    try {
      let response = await axios({
        async: true,
        crossDomain: true,
        url: process.env.VUE_APP_ROOT_API + (teacher ? "prepareExamForTeach/" : "prepareExam/"),
        method: "post",
          params: { examId: examId },
      });

      if (response.data.error == null) {
        this.error = null;
      }

      if (response.data.error != null) {
        this.loading = false;
        this.error = response.data.error;
        Vue.notify({
          group: "appWarning",
          type: "error",
          text: this.error,
        });
      } else if (
        response.data["id"] > 0 &&
        response.data["status"] != "Finished"
      ) {
        this.selected = [];
        this.preparedExam = true;
        this.exam = response.data;
        this.loading = false;
          router.push({ name: 'Exam', params: { groupId: response.data.groupId } });
      } else if (
        response.data["id"] > 0 &&
        response.data["status"] == "Finished"
      ) {
        Vue.notify({
          group: "appWarning",
          type: "error",
          text: "exam was finished for today!",
        });
      } else if (response.data["id"] == 0) {
        Vue.notify({
          group: "appWarning",
          type: "error",
          text: response.data["status"],
        });
      }
    } catch(error) {console.log(error)}
  },

  async previewExamFct() {
    const params = {
      examId: this.exam.id,
    };

    console.log(params);
    try {
      let responseexm = await axios({
        async: true,
        crossDomain: true,
        url: process.env.VUE_APP_ROOT_API + "previewExam/",
        method: "get",
        params: params,
      });

      this.rowExam = responseexm.data;

      this.previewExam = true;
    } catch (error) {}
  },
  startExam(examId) {
    exam.restartExam();
    const oldExamId = sessionStorage.getItem("ExamId");
    if (examId > 0) {
      if (oldExamId && examId != Number.parseInt(oldExamId)) {
        sessionStorage.removeItem("countDown");
      }
      sessionStorage.setItem("ExamId", examId);
    } else {
      if (oldExamId && this.exam.id != Number.parseInt(oldExamId)) {
        sessionStorage.removeItem("countDown");
      }
      sessionStorage.setItem("ExamId", this.exam.id);
    }

    this.preparedExam = false;
    this.previewExam = false;
    this.exam = null;
    router.push({ name: "Exam" });
  },
  getQuestImage(questionAttachment) {
    if (questionAttachment != null) {
      return "/img/quest/" + questionAttachment.name;
    }
  },
  getAnsImage(answerAttachment) {
    if (answerAttachment != null) {
      return "/img/ans/" + answerAttachment.name;
    }
  },
  getDicipline(selectedYear, pkDiscipline) {
    let discip = undefined;
    this.rowUserData.disciplines.forEach((discipline) => {
      if (discipline.pkDiscipline == pkDiscipline) {
        discip = discipline;
      }
    });
    return discip.disciplineDescription;
  },
  cancel() {
    this.preparedExam = false;
    sessionStorage.setItem("ExamId", 0);
  },
});
